export default [

     {
          path: '/biaadmin-manager',
          name: 'BIAAdminManager',
          component: () => import("@/views/Page/BIAAdminManager/BIAAdminManager.vue"),
           meta: {
               title: '#Default# | BIAAdminManager',
          },
     },
     {
          path: '/biaadmin-manager/dashboard',
          name: 'BIAAdminManagerDashboard',
          component: () => import("@/views/Page/BIAAdminManager/BIADashbord.vue"),
           meta: {
               title: '#Default# | BIAAdminManagerDashboard',
          },
     },
];